import { render, staticRenderFns } from "./BackToTopButton.vue?vue&type=template&id=27dd44b0&scoped=true&"
import script from "./BackToTopButton.vue?vue&type=script&lang=js&"
export * from "./BackToTopButton.vue?vue&type=script&lang=js&"
import style0 from "./BackToTopButton.vue?vue&type=style&index=0&id=27dd44b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd44b0",
  null
  
)

export default component.exports